import { Component, DOCUMENT, Inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { ButtonModule } from 'primeng/button';
import { ImageModule } from 'primeng/image';
import { ToolbarModule } from 'primeng/toolbar';
import { Router } from '@angular/router';
import { routesPath } from '../../core/constants/app.constants';

@Component({
    selector: 'app-topbar',
    imports: [ButtonModule,ToolbarModule,ImageModule],
    standalone:true,
    templateUrl: './topbar.component.html',
    styleUrl: './topbar.component.css'
})
export class TopbarComponent {

    isDarkMode: boolean = false;

    constructor(@Inject(DOCUMENT) private doc: Document,
                private router: Router,
                private msalService: MsalService) {
    }

    fnToggleDarkMode(){
        const htmlElement = document.querySelector('html');
        if (htmlElement) {
            htmlElement.classList.toggle('tks-app-dark'); // Toggle the dark mode class
            this.isDarkMode = htmlElement.classList.contains('tks-app-dark');
        }
    }

    async fnCerrarSesion() {

        // Limpia cuenta activa
        this.msalService.instance.setActiveAccount(null);

        // Borra tokens de esta app (no toca Microsoft)
        this.msalService.instance.clearCache();

        // Limpia tu sesión interna si tienes servicios propios
        sessionStorage.clear();

        // Redirige al login de tu app
        await this.router.navigateByUrl('/'+ routesPath.login);

    }
}
